<template>
  <v-list
    rounded
    class="pa-0"
  >
    <v-list-item-group
      v-bind="$attrs"
      v-on="$listeners"
      color="neutral"
      :multiple="multiple"
    >
      <BaseListItem
        v-for="(item, key) in items"
        :key="key"
        :item="item"
        @select="$emit('select')"
      />
    </v-list-item-group>
  </v-list>
</template>

<script>
import BaseListItem from '@/components/BaseListItem.vue';

export default {
  name: 'BaseList',
  components: {
    BaseListItem,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      selectedItems: [],
    };
  },
};
</script>
